/* ==========================================================================
Swiper
https://swiperjs.com/
========================================================================== */

/* ==========================================================================
Card slider function
========================================================================== */
function swiperInit (swiperId) {
  const swiper = new Swiper('#cardSlideshow', {
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      576: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 24
      },
      1200: {
        slidesPerView: 4.25,
        spaceBetween: 24
      }
    },
    grabCursor: true,
    lazy: true,
    mousewheel: {
      forceToAxis: true
    },
    navigation: {
      nextEl: '.swiper-button-next-slideshow',
      prevEl: '.swiper-button-prev-slideshow'
    },
    preloadImages: false,
    threshold: 10
  });
  return swiper;
}

/* ==========================================================================
Card slider initialize function if id exists
========================================================================== */
// Get all swiper instances with class 'card-slideshow'
const swipers = document.querySelectorAll('.card-slideshow');

// Check if there are swipers instances set on page
if (swipers.length) {
  // Loop through all swiper instances
  swipers.forEach(swiper => {
    // Get data attribute 'id'
    const swiperId = swiper.dataset.id;

    // Initialze function 'swiperInit' and pass on 'swiperId'
    swiperInit(swiperId);
  });
}

// console.log('swiper/card-slider.js is loading');
